import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './AnnotationLineIcon.module.css';

const bindClasses = classNameBind.bind(styles);

const AnnotationLineIcon = ({
  viewBox,
  selected,
} = {}) => {
  const x = viewBox.x - 7;
  const y = viewBox.height + viewBox.y - 6;

  return (
    <switch>
      <foreignObject x={x} y={y} width={14} height={14} requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility">
        <div className={bindClasses('note-icon', { selected })} />
      </foreignObject>
    </switch>
  );
};

export default AnnotationLineIcon;
